import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [CategoryCode, setCategoryCode] = React.useState(FetchData.meta.category_code)
  const [FeaturedImage, setFeaturedImage] = React.useState(FetchData.meta.featured_image)

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const type_array = {
    "korean": "Korean",
    "nasu": "nasu",
    "sakhaadhikrit": "sakhaadhikrit",
  }
  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "featured_image": FeaturedImage,
        "category_code": CategoryCode,
      }
    }

    if (ID == "") {
      AdsPOSTApi(data, slugs.db_slug_category)
        .then((res) => {
          // setReload(false)
          setID(res.data.id)
          // setAlertShow(true)
          // setAlertcomp("Class Added Successfully")
          // history.push(`${slugs.category_details}${res.data.slug}`)
          for (let i = 0; i < CategoryNew.length; i++) {
            AdsPOSTApi({
              "title": `${CategoryNew[i].name}-${Title}`,
              "status": "publish",
              meta: {
                // "listing_value": JSON.stringify(CategoryNewCache)
                "batch_name": `${CategoryNew[i].name}-${Title}`,
                "chapters": "[]",
                "category_id": `${res.data.id}`,
                "category_name": `${Title}`
              }
            }, slugs.db_slug_batch)
              .then(r1 => console.log(r1))
              .catch(e => console.log(e))
              .finally(() => {
                if (i == CategoryNew.length - 1) {
                  setReload(false)
                  history.push(`${slugs.category_details}${res.data.slug}`)
                }
              })
          }
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    }
    else
      AdsPUTApi(data, slugs.db_slug_category, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  const [CategoryNew, setCategoryNew] = React.useState([])

  useEffect(() => {
    GetAllCategories()
  }, [])
  const GetAllCategories = () => {
    setReload(true)
    AdsGETApiAuth({
      _fields: "id,title,slug,meta"
    }, `${slugs.db_slug_extra}/6447`)
      .then((res) => {
        setCategoryNew(Object.values(JSON.parse(res.data.meta.listing_value)))
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  return (
    <div>
      {JSON.stringify(CategoryNew)}
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Class Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Class Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Class Code</td>
                <td className="col-6">
                  <input className="input-common"
                    value={CategoryCode} placeholder="Category Code"
                    onChange={(event) => { setCategoryCode(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Featured Image</td>
                <td className="col-6">
                  <ImageUpload
                    ImageUrl={FeaturedImage}
                    setImageUrl={setFeaturedImage}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Class
              </div>
            </div>
          </div>
        </div>
      </div>
      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div>
  )

}